/*  ========================================================================
    # Components - Calendar - Index
    ========================================================================  */

import React from 'react';
import { createRoot } from 'react-dom/client';
import Calendar from './Calendar';

const containers = document.querySelectorAll('div[data-react-app="Calendar"]');

for (let i = 0; i < containers.length; i++) {
  const propsAttribute = containers[i].attributes['data-react-props']?.value || '{}';
  const props = JSON.parse(propsAttribute) || {};

  createRoot(containers[i]).render(<Calendar {...props} />);
}
